import { ChunkStage, World, WorldName } from './world';
import { ParallaxDirection, ParallaxType } from '../../core/modules/Parallax/ParallaxController';
import { RelicName } from '../relics/relic';

import JungleStartChunk from '../chunks/jungle/JungleStartChunk';
import JungleChunk1 from '../chunks/jungle/JungleChunk1';
import JungleChunk2 from '../chunks/jungle/JungleChunk2';
import JungleChunk3 from '../chunks/jungle/JungleChunk3';
import JungleChunk4 from '../chunks/jungle/JungleChunk4';
import JungleEndChunk from '../chunks/jungle/JungleEndChunk';
import JungleChunkRelic1 from '../chunks/jungle/JungleChunkRelic1';
import JungleChunkRelic2 from './../chunks/jungle/JungleChunkRelic2';
import JungleChunkEasy1 from '../chunks/jungle/JungleChunkEasy1';
import JungleChunkEasy2 from '../chunks/jungle/JungleChunkEasy2';
import JungleChunkEasy3 from '../chunks/jungle/JungleChunkEasy3';
import JungleChunkEasy4 from '../chunks/jungle/JungleChunkEasy4';
import JungleChunkHard1 from './../chunks/jungle/JungleChunkHard1';
import JungleChunkHard2 from '../chunks/jungle/JungleChunkHard2';
import JungleChunkHard3 from '../chunks/jungle/JungleChunkHard3';
import JungleChunkHard4 from '../chunks/jungle/JungleChunkHard4';
export const jungleWorld: World = {
  id: WorldName.Jungle,
  texture: 'game-all',
  parallaxLayers: [
    // {
    //   type: ParallaxType.Tile,
    //   texture: 'game-all',
    //   frame: 'bg-sky-jungle.jpg',
    //   depth: 1,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 0.1,
    //   speedY: 0,
    //   naturalDriftX: 0.15,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -300,
      y: 384,
      texture: 'game-all',
      images: [
        {
          frame: 'bg-sky-jungle.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky-jungle.jpg',
          gapBefore: -2
        },
        {
          frame: 'bg-sky-jungle.jpg',
          gapBefore: -2
        }
      ],
      depth: 1,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.1,
      speedY: 0,
      naturalDriftX: 0.15,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 158,
    //   width: 1920,
    //   height: 315,
    //   texture: 'game-all',
    //   frame: 'tile-clouds-jungle.png',
    //   depth: 2,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 0.15,
    //   speedY: 0,
    //   naturalDriftX: 0.35,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -350,
      y: 118.5,
      texture: 'game-all',
      images: [
        {
          frame: 'tile-clouds-jungle.png'
        },
        {
          frame: 'tile-clouds-jungle.png'
        }
      ],
      depth: 2,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.15,
      speedY: 0,
      naturalDriftX: 0.35,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 600,
    //   width: 1920,
    //   height: 203,
    //   texture: 'game-all',
    //   frame: 'tile-back-trees-jungle.png',
    //   depth: 3,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 0.2,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -360,
      y: 676.125,
      texture: 'game-all',
      images: [
        {
          frame: 'tile-back-trees-jungle.png'
        },
        {
          frame: 'tile-back-trees-jungle.png'
        }
      ],
      depth: 3,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.2,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 570,
    //   width: 1920,
    //   height: 396,
    //   texture: 'game-all',
    //   frame: 'tile-trees-jungle.png',
    //   depth: 4,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 0.5,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: -550,
      y: 756,
      texture: 'game-all',
      images: [
        {
          frame: 'tile-trees-jungle.png',
          gapBefore: -2
        },
        {
          frame: 'tile-trees-jungle.png',
          gapBefore: -2
        },
        {
          frame: 'tile-trees-jungle.png',
          gapBefore: -2
        }
      ],
      depth: 4,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.5,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    }
    // In world Y.
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 145,
    //   width: 1920,
    //   height: 396,
    //   texture: 'game-all',
    //   frame: 'tile-trees-jungle.png',
    //   depth: 4,
    //   scrollX: 0,
    //   scrollY: 1,
    //   speedX: 0.75,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // }
  ],
  playerSpawnPoint: { x: 100, y: -20 },
  hasHardFloor: false,
  deathFloorY: 340,
  chunkStartX: 0,
  chunkStartY: 300,
  relics: [
    {
      relic: RelicName.SilverHelmet,
      distance: 15000,
      chunks: [JungleChunkRelic1]
    },
    {
      relic: RelicName.DiamondSkull,
      distance: 30000,
      chunks: [JungleChunkRelic2]
    }
  ],
  chunks: {
    [ChunkStage.Start]: [JungleStartChunk],
    //[ChunkStage.Easy]: [JungleChunkRelic2],
    [ChunkStage.Easy]: [JungleChunkEasy1, JungleChunkEasy2, JungleChunkEasy3, JungleChunkEasy4],
    // [ChunkStage.Easy]: [JungleChunkHard1, JungleChunkHard2, JungleChunkHard3, JungleChunkHard4],
    // [ChunkStage.Mid]: [JungleChunk1, JungleChunk2, JungleChunk3, JungleChunk4],
    [ChunkStage.Hard]: [
      JungleChunkEasy1,
      JungleChunkEasy2,
      JungleChunkEasy3,
      JungleChunkEasy4,
      JungleChunkHard1,
      JungleChunkHard2,
      JungleChunkHard3,
      JungleChunkHard4
    ],
    // [ChunkStage.Mid]: [JungleChunkRelic2],
    [ChunkStage.End]: [JungleEndChunk]
  },
  stageOrdering: [
    {
      name: ChunkStage.Start,
      count: 1
    },
    {
      name: ChunkStage.Easy,
      distance: 37500,
      // count: 1,
      rushMax: 0
    },
    {
      name: ChunkStage.Hard,
      distance: 37500,
      // count: 1,
      rushMin: 1
    },
    {
      name: ChunkStage.End,
      count: 1
    }
  ]
};
